import PropTypes from 'prop-types';
export const displayContextShape = PropTypes.shape({
  route: PropTypes.string,
  url: PropTypes.string,
  browser: PropTypes.string,
  timestamp: PropTypes.string
});
export const feedbackCategoryShape = PropTypes.shape({
  id: PropTypes.string,
  glyph: PropTypes.string,
  optionTitle: PropTypes.string,
  optionDescription: PropTypes.string,
  badgeGlyph: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  submitLabel: PropTypes.string,
  submitColor: PropTypes.string,
  confirmationTitle: PropTypes.string,
  confirmationNote: PropTypes.string
});

/** A feedback category paired with the FormType that supplies its fields. */
export const feedbackFormShape = PropTypes.shape({
  categoryId: PropTypes.string.isRequired,
  identifier: PropTypes.string,
  name: PropTypes.string,
  format: PropTypes.shape({})
});